//------------------------------------------------------------------------
// Automatically add an icon to external links
//------------------------------------------------------------------------
// Import the ES5 code since Webpack isn’t setup to transpile external resources
import Unorphanize from "@threespot/unorphanize";

const externalIcon =
  '<svg class="external-icon" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path stroke="rgba(83,0,185,1)" stroke-linecap="round" stroke-linejoin="round" d="M8 24L24 8"/><path stroke="rgba(83,0,185,1)" stroke-linecap="round" stroke-linejoin="round" d="M11 8H24V21"/></svg>';

const init = () => {
  // Find all external links but ignore buttons
  const links = document.querySelectorAll('.external-icons a[href^="http"]:not(.btn)');

  links.forEach(function(el) {
    // Create a dummy anchor element to easily get the hostname of the href attribute
    // https://gist.github.com/jlong/2428561
    var a = document.createElement("a");
    a.href = el.href;

    // Compare the link hostname to the window hostname
    // to check if it is an external link.
    if (a.hostname !== window.location.hostname) {
      new Unorphanize(el, {
        inlineStyles: false,
        className: "u-nowrap is-external",
        append: externalIcon
      });
    }
  });
};

// Init on initial page load
init();
